const maskedHabitatRoutes = ['help', 'inspiration', 'shop-by-room', 'stores', 'events']
const hullabalookCmsPaths = ['events', 'shop-by-room']

const isHelpPath = (path) => {
  if (!path) return null
  const locationRegex = /\/(.*?)\//
  const getPageType = locationRegex.exec(path)
  return getPageType && getPageType[1] === 'help'
}

const isMaskedHabitatPath = (path) => {
  if (!path) return null
  return maskedHabitatRoutes.some((route) => path.startsWith(`/${route}`) || path.startsWith(`/features/${route}`))
}

const isHomepagePath = (path) => (path && path === '/') || false
const isHabitatHomepagePath = (path) => isHomepagePath(path) && process.env.BRAND === 'habitat'

const isHullabalookCmsPath = (path) => {
  if (!path) return null
  return (
    isHabitatHomepagePath(path) ||
    hullabalookCmsPaths.some((route) => path.startsWith(`/${route}`) || path.startsWith(`/features/${route}`))
  )
}

const isReviewsPath = (path) => (path && path.startsWith('/reviews')) || false
const isRoomCreatorPath = (path) => (path && path.startsWith('/room-creator')) || false
const isGetTheLookPath = (path) => (path && path.startsWith('/get-the-look')) || false
const isReviewsArgosCard = (path) => (path && path.split('reviews/')[1] === 'argos-card') || false

const isCmsPath = (path) => {
  if (!path) return null
  if (isHabitatHomepagePath(path)) return true
  const locationRegex = /\/(.*?)\//
  const getPageType = locationRegex.exec(path)
  return getPageType && ['events', 'brands', 'features'].indexOf(getPageType[1]) !== -1
}
const isMagnoliaApp = (path) => isCmsPath(path) || isHelpPath(path) || isMaskedHabitatPath(path)

const getCleanPath = (path) =>
  path
    .substr(1)
    .split('?')[0]
    .replace(/\//g, '-')

const getHabitatCanonicalPath = (path) => (isMaskedHabitatPath(path) ? path.replace('/features', '') : path)

const getRoute = (path) => {
  if (isHomepagePath(path)) return 'homepage'
  if (isCmsPath(path)) return 'cms'
  if (isHelpPath(path)) return 'help'
  if (isReviewsPath(path)) return 'reviews'
  if (isRoomCreatorPath(path)) return 'room-creator'
  if (isGetTheLookPath(path)) return 'get-the-look'
  return 'errorpage'
}

export {
  maskedHabitatRoutes,
  isCmsPath,
  isHomepagePath,
  isHullabalookCmsPath,
  isHabitatHomepagePath,
  isRoomCreatorPath,
  isGetTheLookPath,
  isMaskedHabitatPath,
  isReviewsPath,
  isHelpPath,
  isMagnoliaApp,
  isReviewsArgosCard,
  getRoute,
  getCleanPath,
  getHabitatCanonicalPath,
}
